(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('rejectedType', {
                parent: 'entity',
                url: '/rejectedTypes',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                    pageTitle: 'uniromaLandingApp.rejectedType.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rejectedType/rejectedTypes.html',
                        controller: 'RejectedTypeController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rejectedType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('rejectedType.detail', {
                parent: 'entity',
                url: '/rejectedType/{id}',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                    pageTitle: 'uniromaLandingApp.rejectedType.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rejectedType/rejectedType-detail.html',
                        controller: 'RejectedTypeDetailController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('rejectedType');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'RejectedType', function($stateParams, RejectedType) {
                        return RejectedType.get({id : $stateParams.id});
                    }]
                }
            })
            .state('rejectedType.new', {
                parent: 'rejectedType',
                url: '/new',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/rejectedType/rejectedType-dialog.html',
                        controller: 'RejectedTypeDialogController',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    name: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function(result) {
                        $state.go('rejectedType', null, { reload: true });
                    }, function() {
                        $state.go('rejectedType');
                    })
                }]
            })
            .state('rejectedType.edit', {
                parent: 'rejectedType',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_LOG_ERRORE'],
                },
                onEnter: ['$stateParams', '$state', '$modal', function($stateParams, $state, $modal) {
                    $modal.open({
                        templateUrl: 'app/entities/rejectedType/rejectedType-dialog.html',
                        controller: 'RejectedTypeDialogController',
                        size: 'lg',
                        resolve: {
                            entity: ['RejectedType', function(RejectedType) {
                                return RejectedType.get({id : $stateParams.id});
                            }]
                        }
                    }).result.then(function(result) {
                        $state.go('rejectedType', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    })
                }]
            });
    }
})();
